import { Button } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { useState } from 'react'
import { ExportP2PCsv } from '../../../../services/peerToPeer/DashboardService'
import { toast } from 'react-toastify'
import { downloadBlob } from '../../../../utils/fileUtils'
import { styles } from './DashboardBanner.styles'

interface Props {
  organizationId: number
  reportingYearId: number
}

export const DashboardExports = ({ organizationId, reportingYearId }: Props): JSX.Element => {
  const [isExporting, setIsExporting] = useState(false)

  const exportCsv = async (): Promise<void> => {
    setIsExporting(true)
    const result = await ExportP2PCsv(organizationId, reportingYearId)
    setIsExporting(false)
    if (!result.success || result.blob == null) {
      toast.error('Could not export data')
      return
    }
    downloadBlob(result.blob, `p2p-${organizationId}-${reportingYearId}.csv`)
  }

  return (
    <Button
      variant='contained'
      onClick={() => { void exportCsv() }}
      disabled={isExporting}
      data-testid='p2pExportData'
      data-hide-in-pdf
      endIcon={<FileDownloadOutlinedIcon />}
      sx={styles.bannerButton}
    >
      Export data
    </Button>
  )
}
